import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Servizi from "@/components/site/Servizi";
import ChiSiamo from "@/components/site/ChiSiamo";
import Pacchetti from "@/components/site/Pacchetti";
import Produzione from "@/components/site/Produzione";
import Clienti from "@/components/site/Clienti";
import Quiz from "@/components/site/Quiz";
import Transformation from "@/components/site/Transformation";
import Contattaci from "@/components/site/Contattaci";
import Footer from "@/components/site/Footer";

export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
  }, [location.hash]);

  return (
    <div data-testid="landing-page" className="relative min-h-screen bg-[#05050A] text-slate-100 overflow-x-hidden font-body">
      <div className="pointer-events-none fixed inset-0 -z-10 opacity-70"
        style={{
          background:
            "radial-gradient(60% 40% at 20% 10%, rgba(147,51,234,0.18) 0%, transparent 60%), radial-gradient(50% 40% at 80% 20%, rgba(59,130,246,0.18) 0%, transparent 60%), radial-gradient(80% 60% at 50% 100%, rgba(147,51,234,0.10) 0%, transparent 70%)",
        }}
      />
      <Nav />
      <main>
        <Hero />
        <Servizi />
        <ChiSiamo />
        <Produzione />
        <Clienti />
        <Pacchetti />
        <Quiz />
        <Transformation />
        <Contattaci />
      </main>
      <Footer />
    </div>
  );
}
